// AI transparency page (IDD D-HP-SITE-031): the transparency duties of Art.\u00a050 of the AI Act (Regulation (EU)
// 2024/1689) as the company meets them, and the competent German authority. German is the authoritative version.
export const aiTransparencyPageFR = {
  seo: {
    title: 'Transparence en matière d’IA | pAIoneer Labs GmbH',
    description: 'Comment pAIoneer Labs GmbH utilise l’intelligence artificielle et informe à ce sujet : assistant IA, marquage des contenus générés par l’IA, responsabilité éditoriale et interlocuteur au titre du règlement sur l’intelligence artificielle.',
    keywords: 'transparence en matière d’IA, règlement sur l’intelligence artificielle, AI Act, art.\u00a050, marquage, assistant IA, pAIoneer Labs GmbH',
    url: 'https://paioneer-labs.eu/ai-transparency',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Transparence en matière d’IA',
      url: 'https://paioneer-labs.eu/ai-transparency',
      isPartOf: {
        '@type': 'WebSite',
        name: 'pAIoneer Labs GmbH',
        url: 'https://paioneer-labs.eu'
      }
    }
  },
  hero: {
    title: 'Transparence en matière d’IA',
    subtitle: 'Comment pAIoneer Labs GmbH utilise l’intelligence artificielle et informe à ce sujet.'
  },
  sections: [
    {
      title: 'Cadre juridique',
      paragraphs: [
        'Depuis le 2 août 2026, les obligations de transparence prévues à l’art.\u00a050 du règlement (UE) 2024/1689 concernant l’intelligence artificielle (règlement sur l’intelligence artificielle) s’appliquent. En Allemagne, en vertu de la KI-Marktüberwachungs- und Innovationsförderungsgesetz (KI-MIG, loi allemande sur la surveillance du marché de l’IA et la promotion de l’innovation), la Bundesnetzagentur (Agence fédérale allemande des réseaux) est l’autorité de surveillance du marché et l’instance chargée des réclamations pour le règlement sur l’intelligence artificielle.',
        'Cette page décrit les systèmes d’IA que pAIoneer Labs GmbH utilise et la manière dont elle informe à ce sujet. La manière dont les données à caractère personnel sont traitées dans ce cadre est décrite dans la politique de confidentialité.'
      ]
    },
    {
      title: 'Assistant IA dans notre application',
      paragraphs: [
        'Dans notre application, un assistant IA répond à vos questions. Il s’agit d’un système d’IA : ses réponses sont générées automatiquement par des modèles de langage et peuvent être erronées. Vérifiez les informations importantes avant de fonder des décisions sur celles-ci.',
        'L’application vous le signale avant votre première saisie et en permanence à côté du chat (art.\u00a050, paragraphe 1, du règlement sur l’intelligence artificielle). En outre, chaque réponse de l’assistant est marquée, dans un format lisible par machine, comme générée par l’IA (art.\u00a050, paragraphe 2, du règlement sur l’intelligence artificielle).',
        'Les modèles de langage sont fournis par l’intermédiaire du service d’OpenRouter, Inc., États-Unis.'
      ]
    },
    {
      title: 'Communication directe avec des systèmes d’IA',
      paragraphs: [
        'Lorsqu’un système d’IA de pAIoneer Labs GmbH communique directement avec vous, par exemple dans un chat, il se fait connaître comme système d’IA au plus tard lors de la première interaction.'
      ]
    },
    {
      title: 'Contenus de ce site web',
      paragraphs: [
        'Les textes de ce site web sont – y compris lorsque des outils d’IA contribuent à leur rédaction – vérifiés par pAIoneer Labs GmbH et publiés sous sa responsabilité éditoriale (art.\u00a050, paragraphe 4, deuxième alinéa, du règlement sur l’intelligence artificielle).',
        'Nous signalons comme générés ou modifiés artificiellement les contenus image, audio ou vidéo qui ont été générés ou modifiés à l’aide de l’IA et qui représentent des personnes, des lieux ou des événements réels avec un réalisme trompeur (art.\u00a050, paragraphe 4, premier alinéa, du règlement sur l’intelligence artificielle).'
      ]
    },
    {
      title: 'Analyse par apprentissage automatique',
      paragraphs: [
        'Avec votre consentement, nous analysons les statistiques de visite à l’aide de méthodes d’apprentissage automatique ; les détails figurent dans la politique de confidentialité. Nous n’utilisons à cet effet ni reconnaissance des émotions ni catégorisation biométrique (art.\u00a050, paragraphe 3, du règlement sur l’intelligence artificielle). La distinction entre les humains et les accès automatisés repose sur des caractéristiques techniques de l’appareil, du navigateur et de la connexion, et non sur des données biométriques.'
      ]
    },
    {
      title: 'Réclamation',
      paragraphs: [
        'Vous pouvez adresser une réclamation concernant une éventuelle violation du règlement sur l’intelligence artificielle à la Bundesnetzagentur, l’autorité de surveillance du marché et l’instance chargée des réclamations pour le règlement sur l’intelligence artificielle en Allemagne. Elle met à disposition des informations à ce sujet sur bundesnetzagentur.de/ki.'
      ]
    }
  ],
  contact: {
    title: 'Contact',
    description: 'Pour toute question relative à l’utilisation de l’intelligence artificielle, vous pouvez nous joindre par e-mail.',
    email: 'info@paioneer.eu'
  },
  lastUpdated: 'Dernière mise à jour : 30 octobre 2026. La version allemande fait foi.'
};
